/* C-03 Button: every action is a capsule (P9). One primary (signal) per view. */
.button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 0 var(--dimension-space-4);
  border-radius: var(--dimension-radius-capsule);
  border: var(--dimension-line-control) solid transparent;
  background: transparent;
  color: var(--color-text-primary);
  font-family: inherit; /* size and weight come from the type class, whatever the CSS order */
  text-align: left;
  cursor: pointer;
}
@media (prefers-reduced-motion: no-preference) {
  .button {
    transition: opacity var(--duration-fast) ease-out;
  }
}
.button:active {
  opacity: 0.75;
}
.button:disabled {
  cursor: default;
  background: var(--color-surface-sunken);
  border-color: transparent;
  color: var(--color-text-disabled);
}
.withIcon {
  padding-right: 6px;
}
.small {
  min-height: 32px;
  gap: 8px;
  padding-left: var(--dimension-space-3);
}
.primary {
  background: var(--color-surface-signal);
  color: var(--color-text-on-signal);
}
.leader {
  background: var(--color-surface-sunken);
}
.ink {
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.outline {
  border-color: var(--color-border-control);
}
.destructive {
  border-color: var(--color-status-danger);
  color: var(--color-status-danger);
}
.ghost {
  min-height: 0;
  padding: 0;
}
.lead {
  width: 24px;
  height: var(--dimension-line-hairline);
  background: currentColor;
  opacity: 0.45;
  flex: none;
}
.small .lead {
  width: 16px;
}
.end {
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border-radius: var(--dimension-radius-capsule);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
  flex: none;
}
.end svg {
  width: 12px;
  height: 12px;
}
.primary .end {
  background: var(--color-text-on-signal);
  color: var(--color-surface-signal);
}
.ink .end {
  background: var(--color-text-on-inverse);
  color: var(--color-surface-inverse);
}
.full {
  display: flex;
  width: 100%;
}
.grow {
  flex: 1;
  text-align: left;
}
